export const ugovor_o_autorskom_djelu = {
    templateId: 45,
    category: 5,
    templateTitle: 'Ugovor o autorskom djelu',
    templateDescription: `<p>Ugovorom o autorskom djelu, autor se obvezuje za naručitelja izraditi autorsko djelo, a naručitelj se obvezuje autoru isplatiti određenu naknadu.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Ugovorom o autorskom djelu autor se obvezuje za naručitelja izraditi autorsko djelo, a naručitelj se obvezuje autoru isplatiti određenu naknadu.</p>
    <p>Autorsko djelo originalna je intelektualna tvorevina iz književnog, znanstvenog ili umjetničkog područja koja ima individualni karakter, bez obzira na način i oblik izražavanja, vrstu, vrijednost ili namjenu, ako zakonom nije drukčije određeno.</p>
    <p>Predmet autorskog ugovora o djelu su autorska djela koja su originalna, duhovna (intelektualna) tvorevina iz književnog, umjetničkog i znanstvenog područja, koje ima individualni karakter i koje je na neki način izraženo. Autorska djela su: </p>
    
    <li> jezična djela, kao što su pisana djela, govorna djela te računalni programi, koji obuhvaćaju izražaj računalnog programa u bilo kojem obliku, uključujući i pripremni dizajnerski materijal,</li>
    <li> glazbena djela, s riječima ili bez riječi, </li>
    <li> dramska i dramsko-glazbena djela, </li>
    <li> koreografska i pantomimska djela, </li>
    <li> djela vizualnih umjetnosti s područja slikarstva, kiparstva i grafike, bez obzira na materijal od kojega su načinjena, te ostala djela vizualnih umjetnosti, </li>
    <li> djela arhitekture, kao što su skice, studije, plastični i drugi prikazi, nacrti, idejna rješenja, idejni projekti, glavni projekti, izvedbeni projekti, planovi te izvedene građevine i zahvati u prostoru iz područja arhitekture, urbanizma i krajobrazne arhitekture, </li>
    <li> djela primijenjenih umjetnosti i industrijskog dizajna,</li>
    <li> fotografska djela i djela proizvedena postupkom koji je sličan fotografskom, </li>
    <li> audiovizualna djela, kao što su kinematografski, televizijski, dokumentarni, crtani, reklamni ili drugi filmovi te druga audiovizualna djela izražena slikama, sa zvukom ili bez zvuka, u vremenski organiziranom slijedu promjena, bez obzira na vrstu podloge na koju su fiksirana, </li>
    <li> novinarska djela, kao što su članci, fotografije i audiovizualni prilozi, </li>
    <li> videoigre i druga multimedijalna djela, </li>
    <li> kartografska djela, </li>
    <li> prikazi znanstvene ili tehničke prirode kao što su crteži, planovi, skice, tablice, </li>
    <li> druge vrste originalnih intelektualnih tvorevina koje imaju individualni karakter.</li>
    <br>
    <p>Autorsko pravo u subjektivnom smislu sadržava: moralna prava autora i imovinska prava autora.</p>
    <p>Moralna prava autora su: pravo prve objave, pravo na priznanje autorstva, pravo na poštovanje autorskog djela te časti i ugleda autora te pravo opoziva.</p>
    <p>Imovinsko pravo je pravo autora da iskorištava svoje djelo i da na drugog prenese pravo iskorištavanja svojeg djela (npr. na izdavača).</p>
    <p>Imovinsko pravo obuhvaća: pravo umnožavanja, pravo distribucije (pravo stavljanja u promet), pravo priopćavanja autorskog djela javnosti i pravo prerade.</p>
    <h5><strong>NAJČEŠĆE GREŠKE</strong></h5>
    <p><strong>- Sklapanje Ugovora o autorskom djelu za poslove koji se ne smatraju poslovima u izradi autorskog djela</strong></p>
    <p>Pojašnjenje: za razliku od ugovora o autorskom djelu čiji predmet je originalna tvorevina, ugovor o djelu može se sklopiti za ​obavljanje sljedećih poslova: djelatnosti trgovačkih putnika, akvizitera, sportskih sudaca i delegata, tumača, prevoditelja, turističkih djelatnika, konzultanata, sudskih vještaka, članova nadzornih odbora, skupština, povjerenstava i slično, stoga zbog navedenog treba razlikovati navedene poslove u odnosu na autorska djela za koja se može sklopiti ugovor o autorskom djelu.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o autorskom pravu i srodnim pravima, Zakon o obveznim odnosima, Zakon o porezu na dohodaka, Zakon o doprinosima.</p>
  `,

    sides: [
        {
            prefix: 'Na temelju Zakona o autorskom pravu i srodnim pravima,',
            signature: 'Naručitelj:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Naručitelj)',
            delimiter: `i`
        },
        {
            signature: 'Autor:',
            inputs: [{
                type: 'input',
                required: true,
                placeholder: 'Ime i prezime',
                inSignature: true,
            },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Ulica i kućni broj',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Mjesto',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'OIB',
                },
            ],
            suffix: ' (u daljnjem tekstu: Autor),'
        }
    ],

    headline: 'zaključuju sljedeći',
    title: 'UGOVOR O AUTORSKOM DJELU',
    noArticleNumbers: false,

    articles: [

        {
            title: 'PREDMET UGOVORA',
            mandatory: true,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {type: 'text', content: 'Predmet ovog Ugovora je izrada sljedećeg autorskog djela:', required: true,},
                        {type: 'textarea', value: '', required: true,  help: 'S obzirom na gore prikazani tekst, ovdje upisujete predmet ugovora.'},
                    ],
                }],
            value: '',
        },  
          {
            title: 'ROK IZVRŠENJA',
            mandatory: true,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {type: 'text', content: 'Autor se obvezuje djelo iz ovog Ugovora izvršiti do', required: true,},
                        {type: 'input', value: '', required: true, help: 'Upisati datum.'},
                        ],
                }],
            value: '',
        },
             {
                    title: 'NAKNADA, DAVANJA',
                    mandatory: true,
                    statements: [
                        {
                            type: 'choice',
                            mandatory: true,
                            editable: false,
                            choices: [
                                {
                                    parts: [
                                        {type: 'text', content: 'Naručitelj se obvezuje za obavljeno autorsko djelo Autoru platiti naknadu (autorski honorar) u iznosu od'},
                                        {type: 'input', value: '', required: true, help: 'Upišite iznos.'},
                                        {type: 'text', content: 'umanjenu na iznos obveznih doprinosa, predujma poreza na dohodak i prireza koje je dužan obračunati, obustaviti i uplatiti Naručitelj.', help: 'Isplatitelj primitka po osnovi drugog dohotka dužan je obračunati, obustaviti i uplatiti prirez istodobno kad Autoru  obračunava i plaća porez na dohodak.'},
                                        {type: 'text', content: '\r\nNaknada se isplaćuje na žiro-račun Autora, IBAN broj:'},
                                        {type: 'input', value: '', required: true,},
                                        {type: 'text', content: ', otvoren kod'},
                                        {type: 'input', value: '', required: true, help: 'Upišite naziv banke u kojoj Autor ima otvoren žiro-račun.'},
                                        {type: 'text', content: 'd.d.. '},
                                    ]
                                },
                                {
                                    parts: [
                                        {type: 'text', content: 'Naručitelj se obvezuje za obavljeno autorsko djelo Autoru platiti naknadu (autorski honorar) u iznosu od'},
                                        {type: 'input', value: '', required: true, help: 'Upišite iznos.'},
                                        {type: 'text', content: 'Naknada se isplaćuje na žiro-račun Autora, IBAN broj:'},
                                        {type: 'input', value: '', required: true,},
                                        {type: 'text', content: ', otvoren kod'},
                                        {type: 'input', value: '', required: true, help: 'Upišite naziv banke u kojoj Autor ima otvoren žiro-račun.'},
                                        {type: 'text', content: 'd.d.. ' },
                                        {type: 'text', content: '\r\nS obzirom da Autor obavlja djelatnost slobodnog zanimanja dužan je sam obračunati i uplatiti prirez istodobno kod obračuna te platiti porez na dohodak.', help:'Autor obveznik poreza na dohodak koji obavlja djelatnost slobodnog zanimanja dužan je sam obračunati i uplatiti prirez istodobno kad obračunava i plaća porez na dohodak.' },

                                    ]
                                }],
                            value: '',
                        }
                    ]
                },
                {
                    title: 'ROK PLAĆANJA',
                    mandatory: true,
                    statements: [
                        {
                            type: 'choice',
                            mandatory: true,
                            editable: false,
                            choices: [
                                {
                                    parts: [
                                        {type: 'text', content: 'Naručitelj je dužan platiti Autoru naknadu (autorski honorar) u roku od'},
                                        {type: 'input', value: '', required: true, help: 'Upisati rok plaćanja.'},]
                                },
                                {
                                    parts: [
                                        {type: 'text', content: 'Naručitelj je dužan platiti Autoru naknadu (autorski honorar) u roku od '},
                                        {type: 'input', value: '', required: true, help: 'Upisati rok plaćanja.'},
                                        {type: 'text', content: 'od dana primitka završenog autorskog djela.'}]
                                },
                        {
                            parts: [
                              { type: "text", content: "Naručitelj je dužan platiti Autoru naknadu (autorski honorar) u sljedećim rokovima:" },
                              {type: "textarea", value: "", required: true },
                              { help: 'Upisati rokove plaćanja.'}
                            ]
                          }
                        ],
                        value: "",
                      },
                    ]
                  },
                  {
                    title: 'ODSTUPANJE OD UGOVORENIH UVJETA',
                    mandatory: false,
                    statements: [
                        {
                            type: 'text',
                            required: false,
                            mandatory: true,
                            editable: true,
                            content: 'Ako se tijekom obavljanja poslova utvrdi da se Autor ne drži obveza iz ovog Ugovora, Naručitelj može upozoriti Autora i odrediti mu primjeran rok da svoj rad uskladi sa svojim obvezama.\r\nAko do isteka roka Autor ne postupi po zahtjevu Naručitelja, Naručitelj može raskinuti Ugovor u pisanom obliku uz otkazni rok od 30 dana i zahtijevati naknadu štete.',
                            value: '',
                        }],
                },
                      {
                    title: 'RASKID UGOVORA PRIJE ROKA',
                    mandatory: false,
                    statements: [
                        {
                            type: 'input',
                            mandatory: true,
                            editable: true,
                            parts: [
                                {type: 'text', content: 'Izvršenje ovog Ugovora o roku predstavlja bitan sastojak ovog Ugovora.\r\nUkoliko je Autor u zakašnjenju sa započinjanjem ili završetkom autorskog djela te je očito da ga neće završiti u roku, Naručitelj može raskinuti ugovor u pisanom obliku uz otkazni rok od'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'dana i zahtijevati naknadu štete.'}],
                        }],
                },
                {
                    title: 'DOSTAVA',
                    mandatory: false,
                    exampleContent: true,
                    statements: [
                        {
                            type: 'text',
                            required: true,
                            mandatory: true,
                            editable: true,
                            content: 'U slučaju otkaza i raskida Ugovora, isti se mora drugoj ugovornoj strani dostaviti preporučenom pošiljkom putem pošte na adresu označenu u ovom Ugovoru ili na drugi pouzdan način.\r\nU slučaju nemogućnosti uredne osobne dostave pisane opomene i dostave otkaza zbog promjene adrese, odbijanja preuzimanja pismena ili drugih načina izbjegavanja primanja pismena, dostava se smatra uredno izvršenom danom predaje preporučene pošiljke pošti, bez obzira na to je li pošta bila u mogućnosti uručiti pisanu opomenu, odnosno otkaz ili drugo pismeno.  ',
                            value: '',
                        },
                    ],
                    value: '',
                }, 
        {
            title: 'AUTORSKA PRAVA',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: true,
                    choices: [
                        'Ugovorne strane su suglasne da nakon izvršenog plaćanja, sva imovinska prava određena Zakonom o autorskom pravu i srodnim pravima (poglavito pravo ekonomskog iskorištavanja) vezana uz autorsko djelo iz ovog Ugovora, automatski prelaze s Autora na Naručitelja te da Autor po pitanju prava na autorsko djelo iz ovog Ugovora neće tražiti bilo kakve druge naknade po bilo kojoj drugoj osnovi.',
                        'Autor zadržava autorsko pravo na autorskom djelu iz ovog Ugovora. Naručitelj može autorsko djelo iz ovog Ugovora izložiti isključivo u svojim poslovnim prostorijama, bez posebne naknade za samo izlaganje. Za svako eventualno javno izlaganje autorskog djela iz ovog Ugovora, ili korištenje istog autorskog djela u promotivne aktivnosti, Naručitelj mora pribaviti prethodnu pisanu suglasnost Autora, a u suprotnom je svako javno izlaganje autorskog djela iz ovog Ugovora zabranjeno. Svako reproduciranje i umnožavanje autorskog djela iz ovog Ugovora najstrože je zabranjeno. U slučaju raskida Ugovora, Autor gubi bilo svako pravo na autorsku naknadu.'
                      ],
                      placeholder: "Odaberite ovdje te potom izmijenite po želji...",
                }
            ]
        },
        {
            title: 'JAMSTVA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Autor jamči Naručitelju da je isključivi vlasnik autorskih prava na autorskom djelu te se obvezuje da će preuzeti na sebe sve eventualne zahtjeve trećih osoba koji bi se eventualno mogli pojaviti protiv Naručitelju.',
                    value: '',
                }],
        },
        {
            title: 'MJERODAVNO PRAVO',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: false,
                    content: 'Na prava i obveze ugovornih stranaka, koja nisu posebno uređena ovim Ugovorom, primjenjuju se odredbe Zakona o autorskom pravu i srodnim pravima.',
                    value: '',
                }],
        },
        {
            title: 'POSLOVNA TAJNA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ovim Ugovorom, Autor se obvezuje čuvati povjerljive podatke do kojih je došao u izvršenju ovog Ugovora. \r\nPovjerljivi podaci su isključivo vlasništvo Naručitelja odnosno trećih osoba.',
                    value: '',
                }],
        },
        {
            title: 'NADLEŽNOST',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Naručitelja.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Autora.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom u'
                                },
                                {type: 'input', value: '',help: "Upišite mjesno nadležni sud. Npr. ...sudom u Zagrebu; ...sudom u Splitu i sl..", required: true},
                                ]
                        }
                    ],
                    value: '',
                }
            ]
        },
        {
            title: 'PRIMJENA UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ugovor se primjenjuje od trenutka potpisa ugovornih strana.',
                    value: '',
                }],
        },
        {
            title: 'PRIMJERCI UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
                    value: '',
                }],
          },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
          {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
          }
        ],
      };




// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/45_ugovor_o_autorskom_djelu.ts